import * as yup from 'yup';

const username = {
  base: yup.string().typeError('errorMessages.string')
};
username.required = username.base.required('errorMessages.required');
username.optional = username.base;

export default username;
